import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import { Link } from 'react-router-dom'

import Nav from './components/Nav'
import { ReactComponent as Star } from '../img/svg/star.svg'
import { ReactComponent as Round } from '../img/svg/icons/circle-solid.svg'
 

 
class SimpleMap extends Component {
    constructor(props) {
        super(props);
        this.state = { 
          isHidden:true
         }
    }
    
  static defaultProps = {
      
    center: {
      lat: 39.25,
      lng: -106.705
    },
    zoom: 9
  };
  toggleHidden () {
    this.setState({
      isHidden: !this.state.isHidden
    })
  }
  render() {
      const FryingpanClosed = ({ text }) => <div className="map-col-2" onClick={this.toggleHidden.bind(this)}>
          <div className="center"> <Star className="alert-icon-sm"/></div>
          <div className="card-map">
            <div className="button-row-2">
              <div>Fryingpan River</div>
              <div>open</div>
            </div>
          </div>
          </div>;

   const FryingpanOpen = ({ text }) => <div className="map-col-2" onClick={this.toggleHidden.bind(this)}>
          <div className="center"> <Star className="alert-icon-sm"/></div>
          <div className="card-map">
            <h3>Fryingpan River</h3>
            <div className="">Notes: Yadda yadda yadda</div>
            </div>
          
          </div>;

    const TextMarkerRound = ({ text }) => <div className="map-col-2">
          <div className="center"> <Round className="map-dot"/></div>
          <div className=""> {text}</div>
          </div>;


    return (
    <>
    <Nav />
        <div style={{ height: '70vh', width: '96%' }} className="map center">
        <GoogleMapReact
        
          bootstrapURLKeys={{ key:'AIzaSyDP_7k3QlxgVxo-c8hM4g14lDJlrv59oXQ'}}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
          hoverDistance="10"
           >


    <> 
        <FryingpanClosed
         lat={39.45}
         lng={-106.9}/>
        </>


       

        
        </GoogleMapReact>

      </div>
      </>
    );
  }
}
 
export default SimpleMap;